import { User } from '../types/auth';
import { decodeJWT } from './decodeJWT';

export const setUserData = (user: User) => {
  if (user?.constructor.name !== 'Object') {
    throw new Error('No valid data found');
  }
  if (Object.keys(user).length === 0) {
    throw new Error('No data found');
  }
  if (typeof Storage === 'undefined') {
    throw new Error('No valid storage type found');
  }
  sessionStorage.setItem('user', JSON.stringify(user));
};

export function clearUserData(): void {
  if (typeof Storage === 'undefined') return;
  sessionStorage.removeItem('user');
}

export const getRefreshToken = () => {
  if (typeof Storage === 'undefined') return null;
  return JSON.parse(sessionStorage.getItem('user') || '{}')?.refreshToken;
};

export const getAccessToken = () => {
  if (typeof Storage === 'undefined') {
    return new Error('Storage type not valid');
  }
  return JSON.parse(sessionStorage.getItem('user') || '{}')?.accessToken;
};

export const isAuthenticated = () => {
  const accessToken = getAccessToken();
  if (!accessToken) return false;
  return true;
};

export const getUserPermissions = () => {
  const accessToken = getAccessToken();
  const decodedJWTTokenData = accessToken ? decodeJWT(accessToken) : null;
  const accessPages = decodedJWTTokenData?.permisos?.split(';') || [];
  return accessPages;
};

export const userHasPermission = (permission: string) => {
  const userPermissions = getUserPermissions();
  return userPermissions.includes(permission);
};
